import React, { PureComponent } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Record } from "immutable"
import { NavLink } from "react-router-dom"
import ReactTooltip from "react-tooltip"

// helpers
import { shortenString } from "helpers/string.helper"
import { getRoutePath } from "routes"

// selectors
import { getWorkspaceRecord } from "selectors/workspace.selector"

class WorkspaceJobSubmenu extends PureComponent {
  render() {
    const { workspace } = this.props

    if (!workspace) {
      return null
    }

    const hasWorkspaceTooltip = workspace.name.length >= 25
    const workspaceTooltipProps = hasWorkspaceTooltip
      ? { "data-tip": workspace.name, "data-for": "navigation-tooltip" }
      : {}

    return (
      <React.Fragment>
        <nav className="secondary-nav">
          <NavLink to={getRoutePath("workspace.list")}>Workspaces</NavLink>
          <FontAwesomeIcon className="chevron-icon" icon={["far", "chevron-right"]} />
          <NavLink
            className="has-ws-icon"
            to={getRoutePath("workspace.show", { id: workspace.id })}
            {...workspaceTooltipProps}
          >
            <FontAwesomeIcon className="prefix-icon" icon={["fas", "code-branch"]} />
            {shortenString(workspace.name, 25)}
          </NavLink>
          <FontAwesomeIcon className="chevron-icon" icon={["far", "chevron-right"]} />
          <NavLink
            to={getRoutePath("workspace.workspaceJob.list", {
              id: workspace.id
            })}
          >
            Activity
          </NavLink>
          <FontAwesomeIcon className="chevron-icon" icon={["far", "chevron-right"]} />
          <span className="link-like is-active">Activity Detail</span>
        </nav>
        <ReactTooltip id="navigation-tooltip" getContent={dataTip => dataTip} place="bottom" />
      </React.Fragment>
    )
  }
}

WorkspaceJobSubmenu.propTypes = {
  workspace: PropTypes.instanceOf(Record)
}

const mapStateToProps = (state, ownProps) => {
  const {
    match: {
      params: { id }
    }
  } = ownProps
  return {
    workspace: getWorkspaceRecord(state, id)
  }
}

export default connect(mapStateToProps)(WorkspaceJobSubmenu)
